var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.qrContent)?_c('div',{staticClass:"card-info"},[_c('p',{staticClass:"created-date"},[_vm._v(_vm._s(_vm.readingDate))]),_vm._v(" "+_vm._s(_vm.qrContent)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }